import { apiClient, type PageEntity, type TruckModelEntity } from '@/libs/api'
import type { TruckModelsListRequestQuery } from '@/libs/api/types'

export type FetchTruckModelsListQuery = {
  tenantKey: string
  query?: TruckModelsListRequestQuery
}

export type FetchTruckModelsListResponse = {
  data: TruckModelEntity[]
  pagination: PageEntity | null
}

/**
 * 車種一覧を取得
 */
export const fetchTruckModelsList = async (
  { tenantKey, query }: FetchTruckModelsListQuery,
  signal?: AbortSignal
): Promise<FetchTruckModelsListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_models.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
